window.TV2 = window.TV2 || {};

window.TV2.initSlideover = (id) => {
  const container = document.querySelector(`#tv2-slideover-${id}`);
  const comparison = document.querySelector(
    `#tv2-slideover-${id} .slideover__comparison`
  );
  const divisor = document.querySelector(
    `#tv2-slideover-${id} .slideover__image:nth-child(2)`
  );
  const dragger = document.querySelector(
    `#tv2-slideover-${id} .slideover__dragger`
  );

  const divisorImage = divisor && divisor.querySelector("img");

  if (divisorImage) {
    container.classList.remove("slideover--loading");
    divisorImage.style.width = `${comparison.offsetWidth}px`;
  } else {
    return;
  }

  function moveDivisor(e) {
    e.stopPropagation();
    e.preventDefault();
    const { left } = container.getBoundingClientRect();

    const pos = e.touches
      ? ((e.touches[0].clientX - left - 4) / comparison.offsetWidth) * 100
      : ((e.clientX - left - 4) / comparison.offsetWidth) * 100;

    const divisorPos = Math.min(100, Math.max(0, pos));

    divisor.style.width = `${divisorPos}%`;
    dragger.style.left = `${divisorPos}%`;
  }

  // Mousedrag
  dragger.addEventListener("mousedown", () => {
    document.body.addEventListener("mousemove", moveDivisor);
  });
  document.body.addEventListener("mouseup", () => {
    document.body.removeEventListener("mousemove", moveDivisor);
  });

  // Touch
  comparison.addEventListener("touchstart", () => {
    document.body.addEventListener("touchmove", moveDivisor);
  });
  document.body.addEventListener("touchend", () => {
    document.body.removeEventListener("touchmove", moveDivisor);
  });
};
